let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("128yZ")).then(() => parcelRequire('he0oB'));